// NOTE: must be kept in sync with
// packages/applicant-ui/app/utils/logUnreachable.ts
// packages/fountain-ui-components/src/utils/logUnreachable.ts
export function logUnreachable(condition: never, metadata?: string) {
  // eslint-disable-next-line no-console
  console.error(
    `Unknown condition reached: ${condition as string} - ${metadata ?? ''}`,
  );
  return null;
}
